<div class="hint">
  <div class="hint__sign">
    ?
  </div>
  <div class="hint__text">
    {{ text }}
  </div>
</div>
